export default __webpack_public_path__ + "static/media/ion_open-outline_dark.c8c8c4f4.svg";